import React, { FunctionComponent, useEffect, useState } from 'react'

import LottieView, { AnimationObject } from 'lottie-react-native'
import styled, { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'
import { isChromaticWeb, tID } from '../../utils/utils'

const Container = styled.View<{ width: number; height: number }>(({ width, height }) => ({
  height: `${height}px`,
  width: `${width}px`,
}))

export interface RotatingProvidersLottieProps {
  width: number
  height: number
}

export const RotatingProvidersLottie: FunctionComponent<RotatingProvidersLottieProps> = ({ width, height }) => {
  const { isDarkMode } = useTheme() as ThemeType
  const [animationData, setAnimationData] = useState<AnimationObject | null>(null)

  useEffect(() => {
    const loadAnimation = async () => {
      const darkMod = await import('../../assets/lottie/rotatingProvidersLottieDarkMode.json')
      const lightMod = await import('../../assets/lottie/rotatingProvidersLottieLightMode.json')
      const selected = (
        isDarkMode
          ? (darkMod as any).default ?? (darkMod as unknown as AnimationObject)
          : (lightMod as any).default ?? (lightMod as unknown as AnimationObject)
      ) as AnimationObject
      // Clone to avoid lottie-web mutating a frozen/readonly object in SB/Vite
      setAnimationData(JSON.parse(JSON.stringify(selected)))
    }
    loadAnimation()
  }, [isDarkMode])

  return (
    <Container width={width} height={height} testID={tID('HomebaseHeader-rotatingProvidersLottie')}>
      {animationData && (
        <LottieView
          source={animationData}
          loop={!isChromaticWeb()}
          autoPlay={!isChromaticWeb()}
          style={{ width: width, height: height }}
        />
      )}
    </Container>
  )
}
